export enum THEME {
  DARK = "black",
  LIGHT = "white",
}

export enum WindiMap {
  black = "dark",
  white = "light",
}

export function getThemeColor(key) {
  return function (props) {
    return props.theme[key];
  };
}
// export function getColor(themes,colors:Array<string>){
//     if(Array.isArray(colors) && colors.length===2)
//     return themes===THEME.DARK?colors[1]:colors[0]
// }
export function getStyle(...args) {
  const [dark, light] = args.length > 1 ? args : args[0];
  return function (props) {
    return props.theme.theme === THEME.DARK ? dark : light;
  };
}
export const W_TEXT_LIGHT = "#6F6F6F";
export const W_TEXT_DARK = "#99A1A8";
export const COLOR_BG_DARK = "#0d0e0e";
export const MAIN_DEEP_BLUE = "#191919";
export const MAIN_DEEP_BLACK = "#121314";
export const MAIN_DARK = "#1E1E1E";
export const MAIN_DEEP_WHITE = "#FFFFFF";
export const MAIN_GOLD = "#CFB47C";

// 买入 涨 老版本色值
export const MAIN_BUY_LIGHT = "#2AF438";
export const MAIN_BUY_DARK = "#2AF438";
// 卖出 跌
export const MAIN_SELL_LIGHT = "#F1493F";
export const MAIN_SELL_DARK = "#F1493F";

export const MAIN_BLUE = "#2AF438";
export const MAIN_PRIMARY = "#2AF438";

export const MAIN_GREEN_RISE = "rgba(29,162,180,0.09)";
export const MAIN_RED_FALL = "rgba(241,73,63,0.12)";

export const DROP_DOWN_MENU_BG = "#192D53";
export const NO_THEME_RED = "#F1493F";
// export const NO_THEME_GREY = '#ff0000'
export const NO_THEME_GREY = "#697281";

export const MAIN_WARN_RED = "#F1493F";
export const MAIN_ORANGE = "#ff7b1a";
export const MAIN_DEEP_GREEN = "#2AF438";

export const DARK_232323 = "#232323";
export const DARK_0D0E0E = "#0D0E0E";
export const DARK_282828 = "#282828";
export const DARK_181A1A = "#181A1A";
export const DARK_2c2e2e = "#2c2e2e";
export const DARK_191D1D = "#191D1D";
export const GRAY_484848 = "#484848";
export const GRAY_7d7d7d = "#7D7D7D";
export const GRAY_414747 = "#414747";
export const GRAY_222525 = "#222525";
export const DARK_2c3138 = "#2c3138";
export const DARK_1F2121 = "#1F2121";

export const GRAY_6e6e6e = "#6e6e6e";
export const WHITE_e4e4e4 = "#e4e4e4";
export const WHITE_f7f7f7 = "#f7f7f7";
export const WHITE_f8f8f8 = "#f8f8f8";
export const WHITE_F5F4F4 = "#f5f4f4";
export const WHITE_F5F5F4 = "#f5f5f4";
export const WHITE_2b2e39 = "#2b2e39";

export const WHITE_ALPHA = "rgba(0,0,0,0.2)";

export const DARK_MODULE_191919 = "#191919";
export const WHITE_MODULE_FFF = "#ffffff";

export const DARK_THEME_747676 = "#747676";
export const WHITE_THEME_9d9d9d = "#9d9d9d";

export const WHITE_THEME_929899 = "#929899";

export const WHITE_SHADOW_B6B6B6 = "#B6B6B6";
export const DARK_SHADOW = "rgba(0,0,0,0.52)";

export const DARK_INPUT_232323 = "#232323";

//新增现货tableheader颜色常量定义
export const DARK_BG = "#0D0E0E";
export const WHITE_BG = "#ffffff";

export const DARK_CARD_BORDER = "#414747";
export const WHITE_CARD_BORDER = "#eff1f1";

export const DARK_LINE = "#222525";
export const WHITE_LINE = "#eff1f1";

// 透明
// export const DARK_MODULE_191919_OPACITY0 = 'rgba(25 25 25,0)'

export const H00 = [MAIN_DEEP_WHITE, MAIN_DARK];
export const H01 = [GRAY_7d7d7d, GRAY_6e6e6e];
export const H02 = [GRAY_484848, WHITE_e4e4e4];
export const H03 = [MAIN_DEEP_BLUE, WHITE_f7f7f7];
export const H04 = [MAIN_DARK, MAIN_DEEP_WHITE];
export const H04_2 = [MAIN_DARK, WHITE_f7f7f7];
export const H05 = [GRAY_484848, MAIN_DEEP_WHITE];
export const H06 = [DARK_232323, MAIN_DEEP_WHITE];
export const H07 = [MAIN_DEEP_BLACK, WHITE_e4e4e4];
export const H08 = [DARK_MODULE_191919, WHITE_MODULE_FFF];
export const H09 = [DARK_282828, WHITE_F5F4F4];
export const H10 = [DARK_181A1A, WHITE_F5F5F4];
export const H11 = [DARK_282828, MAIN_DEEP_WHITE];
export const H12 = [DARK_THEME_747676, WHITE_THEME_9d9d9d];
export const H13 = [MAIN_DEEP_WHITE, DARK_181A1A];

export const H14 = [DARK_THEME_747676, WHITE_THEME_929899];
export const H15 = [WHITE_f7f7f7, MAIN_DARK];
export const dialogTextColor = [GRAY_7d7d7d, NO_THEME_GREY];
export const SHADOW = [DARK_SHADOW, WHITE_SHADOW_B6B6B6];
export const H16 = [DARK_INPUT_232323, WHITE_e4e4e4];
export const H17 = [WHITE_MODULE_FFF, WHITE_2b2e39];

export const CARDBG = [DARK_BG, WHITE_BG];

export const Mix_color = ["bg-outline-lt", "bg-outline-dk"];

export {};

// 主题大改版新增颜色值的js使用变量
export const NewThemeGreenLight = "#0dbe53";
export const NewThemeGreenDark = "#2AF438";
export const NewThemeRedLight = "#F1493F";
export const NewThemeRedDark = "#F1493F";
export const NewThemeBuyLight = "#0dbe53";
export const NewThemeBuyDark = "#2AF438";
export const NewThemeSellLight = "#F1493F";
export const NewThemeSellDark = "#F1493F";
export const NewThemePrimary = "#2AF438";
// K线周期 大盒子阴影
export const shadowColor = ["#00000050", "#92A0AB28"];
export const klineDateBakcground = ["#0D0E0E", "#ffffff"];
